module.exports = __webpack_public_path__ + "static/hcm-mobile-screen1-41467115de6a9c55cb2b5072380dc96f.jpeg";